import DatePicker from 'vuejs-datepicker';
import * as moment from 'moment';
import AppModal from '../components/modals/AppModal';

export default {
  components: {
    AppModal,
    DatePicker,
  },
  data() {
    return {
      selectedExpirationDate: '',
      isValid: true,
    };
  },
  methods: {
    cancel() {
      this.selectedExpirationDate = '';
      this.$emit('cancel');
    },
    dateFormatter(date) {
      return moment(date).startOf('day').format('MM/DD/YYYY');
    },
    dateSelected() {
      /* Validate on confirm */
      this.validateSelectedDate(this.selectedExpirationDate);
      if (this.isValid) {
        /* MUST be defined in component using this mixin */
        this.emitConfirmedEvent(moment(this.selectedExpirationDate).startOf('day').toDate());
        this.selectedExpirationDate = '';
        this.$root.$emit('bv::hide::modal', this.modalId);
      }
    },
    formattedMaxExpirationString() {
      return this.formattedShortDateString(this.maxExpireDate());
    },
    formattedMinExpirationString() {
      return this.formattedShortDateString(this.minExpireDate());
    },
    /* Format and return string representation. Format example: Mar 21st 2019 */
    formattedShortDateString(date) {
      return moment(date).format('MMM Do YYYY').toString();
    },
    minExpireDate() {
      return moment().add(1, 'days').startOf('day').toDate();
    },
    /* The parameter '[]' of isBetween indicates the inclusion of minExpireDate and maxExpireDate in the check */
    validateSelectedDate(date) {
      if (moment(date).isValid()) {
        this.isValid = this.isValidRenewalDate(date);
      } else {
        this.isValid = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/util/choose-expiration-mixin.js